exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-webkit-input-placeholder{text-transform:none}:-moz-placeholder,::-moz-placeholder{text-transform:none}:-ms-input-placeholder{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-afa99666","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/site/MailSend.vue
// module id = 170
// module chunks = 1